module.exports = __webpack_public_path__ + "static/media/Subtract04.885a1915.svg";